import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';
import { convertBlocksToSeconds } from 'modules/api/utils';

const ONE_DAY_IN_SECONDS = 86400;

export interface IGetCommissionInfo {
  totalDelayDays: number;
  remainingDays: number;
  maxCommission: BigNumber;
}

export async function getCommissionInfo(
  client: PublicClient,
  poolAddress: Address,
): Promise<IGetCommissionInfo> {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  const [lastFeeChangeBlockRaw, feeLockPeriodRaw, maxFeeRaw, currentBlockRaw] =
    await Promise.all([
      poolContract.read.lastFeeChange(),
      poolContract.read.FEE_LOCK_PERIOD(),
      poolContract.read.MAX_POOL_FEE(),
      client.getBlockNumber(),
    ]);

  const currentBlock = Number(currentBlockRaw);
  const lastFeeChangeBlock = Number(lastFeeChangeBlockRaw);
  const feeLockPeriod = Number(feeLockPeriodRaw);
  const maxFee = Number(maxFeeRaw);

  const blocksSinceLastChange = currentBlock - lastFeeChangeBlock;

  const totalDelayDays = Math.ceil(
    convertBlocksToSeconds(feeLockPeriod) / ONE_DAY_IN_SECONDS,
  );
  const remainingDays = Math.ceil(
    convertBlocksToSeconds(feeLockPeriod - blocksSinceLastChange) /
      ONE_DAY_IN_SECONDS,
  );

  const positiveRemainingDays = Math.max(remainingDays, 0);

  return {
    totalDelayDays,
    remainingDays: positiveRemainingDays,
    maxCommission: new BigNumber(maxFee),
  };
}
